import { TOGGLE_NEW_ORDER_POPUP } from './constants';

export const toggleNewOrderPopup = isVisible => ({
    type: TOGGLE_NEW_ORDER_POPUP,
    isVisible,
});
